/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Button, Icon, Tooltip, VFlow } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { MChatRiscoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { isEmpty } from 'lodash'

import { MChatAccessDocLink } from '../components/MChatAccessDocLink'
import { MChatAccordion } from '../components/MChatAccordion'
import { MChatAccordionSection } from '../components/MChatAccordionSection'
import { MChatAccordionStepper } from '../components/MChatAccordionStepper'
import { convertMChatToPerguntaRespostaInput } from '../converter-mchat'
import { downloadMChat } from '../impressao/downloadMChat'
import { MChatAccordionSectionEnum, MChatFieldModel, MChatRFViewModel } from '../model-mchat'

interface MChatViewProps {
  value: MChatRFViewModel
}

export function MChatView(props: MChatViewProps) {
  const { value } = props

  const { M_CHAT_RF_ENABLED } = useFlags()
  const {
    atendimentoProfissional: { id: atendProfId },
    cidadao: { id: cidadaoId },
  } = useAtendimentoContext()

  const hasValuesMChatR = !isEmpty(value.mchatr)
  const hasValuesConsultaSeguimento = !isEmpty(value.consultaSeguimento)
  const isMChatrRiscoElevado = value.mchatr?.risco === MChatRiscoEnum.ELEVADO

  const handlePrint = (mchat: MChatFieldModel) => {
    downloadMChat({
      atendProfId: hasValuesMChatR ? value.mchatr.atendimentoProfissionalId : atendProfId,
      cidadaoId: cidadaoId,
      resultado: mchat.resultado,
      risco: mchat.risco,
      aplicacao: convertMChatToPerguntaRespostaInput(mchat),
    })
  }

  return (
    <MChatAccordion>
      <VFlow vSpacing={0}>
        <MChatAccordionSection
          section={MChatAccordionSectionEnum.MCHATR}
          value={value.mchatr}
          stepper={
            <MChatAccordionStepper
              showPendingIcon={!hasValuesMChatR}
              showCheckIcon={hasValuesMChatR}
              showConnector={value.mchatr.risco === MChatRiscoEnum.MEDIO}
              showExclamationIcon={false}
            />
          }
          secondaryActions={
            <Tooltip text='Imprimir'>
              <Button type='button' kind='normal' skin='ghost' size='small' onClick={() => handlePrint(value.mchatr)}>
                <Icon icon='printerOutline' />
              </Button>
            </Tooltip>
          }
          footerInfo={value.mchatr}
        />
        {!isMChatrRiscoElevado && (
          <MChatAccordionSection
            section={MChatAccordionSectionEnum.CONSULTA_SEGUIMENTO}
            value={value.consultaSeguimento}
            isConsultaSeguimentoAtiva={value.mchatr.risco === MChatRiscoEnum.MEDIO}
            stepper={
              <MChatAccordionStepper
                showPendingIcon={!hasValuesConsultaSeguimento && value.mchatr.risco !== MChatRiscoEnum.MEDIO}
                showCheckIcon={hasValuesConsultaSeguimento}
                showConnector={false}
                showExclamationIcon={!hasValuesConsultaSeguimento && value.mchatr.risco === MChatRiscoEnum.MEDIO}
              />
            }
            primaryActions={!M_CHAT_RF_ENABLED && <MChatAccessDocLink />}
            footerInfo={value.consultaSeguimento}
          />
        )}
      </VFlow>
    </MChatAccordion>
  )
}
